import { hasYesOrNo } from 'models/validate';
import foreignBusinessVotingItemValidator from 'forms/sections/foreign/business/voting/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { ForeignBusinessVotingModel } from './types';

const foreignBusinessVotingValidator: ValidateJSModel<ForeignBusinessVotingModel> = {
  HasForeignVoting: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignVoting?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessVotingItemValidator },
      };
    }
    return {};
  },
};

export default foreignBusinessVotingValidator;
